import { useAtomValue } from 'jotai'
import React from 'react'

import { surveyIdAtom } from '../../atoms'

export const useSurveyFiltersQueryKey = () => {
  const surveyId = useAtomValue(surveyIdAtom)

  return React.useMemo(
    () => ['SurveyFilterInformation_SurveyFilters', { surveyId }],
    [surveyId],
  )
}
